import e, { useState as n, useContext as t, useEffect as r } from "react";
import { BitlyClient as o } from "bitly";
var a = e.createContext({
    bitly: {}
  }),
  i = function i(n) {
    var t = n.children,
      r = n.config,
      i = r.accessToken,
      c = r.options,
      u = new o(i, void 0 === c ? {} : c);
    return e.createElement(a.Provider, {
      value: {
        bitly: u
      }
    }, t);
  };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
function c(e, n, t, r) {
  return new (t || (t = Promise))(function (o, a) {
    function i(e) {
      try {
        u(r.next(e));
      } catch (e) {
        a(e);
      }
    }
    function c(e) {
      try {
        u(r.throw(e));
      } catch (e) {
        a(e);
      }
    }
    function u(e) {
      var n;
      e.done ? o(e.value) : (n = e.value, n instanceof t ? n : new t(function (e) {
        e(n);
      })).then(i, c);
    }
    u((r = r.apply(e, n || [])).next());
  });
}
function u(e, n) {
  var t,
    r,
    o,
    a,
    i = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
  return a = {
    next: c(0),
    throw: c(1),
    return: c(2)
  }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
    return this;
  }), a;
  function c(a) {
    return function (c) {
      return function (a) {
        if (t) throw new TypeError("Generator is already executing.");
        for (; i;) try {
          if (t = 1, r && (o = 2 & a[0] ? r.return : a[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, a[1])).done) return o;
          switch (r = 0, o && (a = [2 & a[0], o.value]), a[0]) {
            case 0:
            case 1:
              o = a;
              break;
            case 4:
              return i.label++, {
                value: a[1],
                done: !1
              };
            case 5:
              i.label++, r = a[1], a = [0];
              continue;
            case 7:
              a = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!(o = i.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                i = 0;
                continue;
              }
              if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                i.label = a[1];
                break;
              }
              if (6 === a[0] && i.label < o[1]) {
                i.label = o[1], o = a;
                break;
              }
              if (o && i.label < o[2]) {
                i.label = o[2], i.ops.push(a);
                break;
              }
              o[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          a = n.call(e, i);
        } catch (e) {
          a = [6, e], r = 0;
        } finally {
          t = o = 0;
        }
        if (5 & a[0]) throw a[1];
        return {
          value: a[0] ? a[1] : void 0,
          done: !0
        };
      }([a, c]);
    };
  }
}
var l = function l(e) {
  var o = n(!1),
    i = o[0],
    l = o[1],
    s = n(null),
    f = s[0],
    p = s[1],
    b = n(),
    h = b[0],
    v = b[1],
    y = t(a).bitly;
  return r(function () {
    c(void 0, void 0, void 0, function () {
      var n, t;
      return u(this, function (r) {
        switch (r.label) {
          case 0:
            l(!0), r.label = 1;
          case 1:
            return r.trys.push([1, 3,, 4]), n = v, [4, y.shorten(e)];
          case 2:
            return n.apply(void 0, [r.sent()]), l(!1), [3, 4];
          case 3:
            return t = r.sent(), p(t), l(!1), [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, [y, e]), {
    loading: i,
    error: f,
    data: h
  };
};
export { i as ShortenUrlProvider, l as useShortenUrl };